import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import {
  breakpointSizes,
  minBreakpointQuery,
  brandColours,
  fontSize,
} from '../styles';
import { Slider } from './ui';

const StyledCardSlider = styled.div``;

const StyledPosition = styled.span`
  position: absolute;
  top: 10px;
  right: 100px;
  letter-spacing: 2px;

  ${minBreakpointQuery.small`
    top: 14px;
    right: 120px;
    ${fontSize(18)};
  `}
`;

const StyledSlider = styled(Slider)`
  position: initial;

  ${({ dots }) => {
    if (dots) {
      return css`
        padding-bottom: 30px;

        ${minBreakpointQuery.small`
          padding-bottom: 40px;
        `}

        ${minBreakpointQuery.large`
          padding-bottom: 50px;
        `}
      `;
    }
  }}

  .slick-list,
  .slick-slide > div {
    height: 100%;
  }

  .slick-list {
    margin: 0 -10px;
  }

  .slick-track {
    display: flex;
  }

  .slick-slide {
    padding: 0 10px;
    height: initial;
  }

  .slick-arrow {
    top: 0;
    height: 40px;
    width: 40px;
    border: 1px solid ${brandColours.primary};

    ${minBreakpointQuery.small`
      height: 50px;
      width: 50px;
    `}

    &.slick-prev {
      right: 50px;

      ${minBreakpointQuery.small`
        right: 60px;
      `}
    }

    &.slick-next {
      right: 0;
    }
  }
`;

const CardSlider = ({ dots = true, children, ...props }) => {
  const [currentSlideNumber, setCurrentSlideNumber] = useState(1);

  const sliderOptions = {
    dots: dots,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: breakpointSizes.mlarge - 1,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: breakpointSizes.small - 1,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    beforeChange: (oldIndex, newIndex) => {
      setCurrentSlideNumber(newIndex + 1);
    },
  };

  return (
    <StyledCardSlider {...props}>
      <StyledPosition className="card-slider-position">
        {currentSlideNumber}/{children.length}
      </StyledPosition>
      <StyledSlider dots={dots} {...sliderOptions}>
        {children}
      </StyledSlider>
    </StyledCardSlider>
  );
};

export default CardSlider;
